import { RollerProductType } from '../../constants/productTypes';
import { ProductBuilderMachineState } from '../../types';

type RollerStatesByProductType = {
  [key in RollerProductType]: ProductBuilderMachineState[];
};

export const allRollerStates: ProductBuilderMachineState[] = [
  'materialType',
  'materialTypeNight',
  'colourNight',
  'materialTypeDay',
  'colour',
  'colourDay',
  'dayFabricPosition',
  'driveControl',
  'smartRelease',
  'bracketColour',
  'fitting',
  'measurements',
  // 'measureInsurance',
  'rollDirection',
  'powerSupply',
  'wifiHub',
  'remoteControl',
  'chainPosition',
  'chainType',
  // 'chainColour',

  // 'commonValance',
  // 'bottomRailColour',
  // 'fascia',
  'lightGuards',
  // 'holdDownBrackets',
  // 'mountingSurface',
  'roomName',
  // 'shipping',
  'complete',
];

const dayNightCorded = allRollerStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'materialType',
    'colour',
    'powerSupply',
    'wifiHub',
    'remoteControl',
    'rollDirection',
    'smartRelease',
    'fascia',
    'chainPosition',
    'bracketColour'
  ];
  return !blackList.includes(state);
});

const dayNightCordless = allRollerStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'materialType',
    'colour',
    'powerSupply',
    'wifiHub',
    'remoteControl',
    'chainPosition',
    'chainColour',
    'chainType',
    'rollDirection',
    'smartRelease',
    'fascia',
    'bracketColour'
  ];
  return !blackList.includes(state);
});

const singleCorded = allRollerStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'materialTypeDay',
    'materialTypeNight',
    'colourDay',
    'colourNight',
    'dayFabricPosition',
    'powerSupply',
    'wifiHub',
    'remoteControl',
    'bracketColour'
  ];
  return !blackList.includes(state);
});

const singleCordless = allRollerStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'materialTypeDay',
    'materialTypeNight',
    'colourDay',
    'colourNight',
    'dayFabricPosition',
    'powerSupply',
    'wifiHub',
    'remoteControl',
    'chainPosition',
    'chainColour',
    'smartRelease',
    'bracketColour',
    'chainType',
  ];
  return !blackList.includes(state);
});

const essentialCorded = allRollerStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'materialTypeDay',
    'materialTypeNight',
    'colourDay',
    'colourNight',
    'dayFabricPosition',
    'smartRelease',
    'lightGuards',
    'powerSupply',
    'wifiHub',
    'remoteControl',
    'bracketColour'
  ];
  return !blackList.includes(state);
});

const rollerPremiumCorded = allRollerStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'materialTypeDay',
    'materialTypeNight',
    'colourDay',
    'colourNight',
    'dayFabricPosition',
    'driveControl',
    'powerSupply',
    'wifiHub',
    // 'chainType',
    'remoteControl',
    'smartRelease',
    'lightGuards',
  ];
  return !blackList.includes(state);
});

export const singleCordedWatson = allRollerStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'materialTypeDay',
    'materialTypeNight',
    'colourDay',
    'colourNight',
    'dayFabricPosition',
    'powerSupply',
    'wifiHub',
    'remoteControl',
    'smartRelease',
    'chainType',
    'lightGuards'
  ];
  return !blackList.includes(state);
});

export const rollerStatesByProductType: RollerStatesByProductType = {
  'Roller Blind Day/Night Chain': dayNightCorded,
  'Roller Blind Day/Night Chainless': dayNightCordless,
  'Roller Blind Single Chain': singleCorded,
  'Roller Blind Single Chainless': singleCordless,
  'Roller Blind Essentials Chain': essentialCorded,
  'Roller Blind Premium Chain': rollerPremiumCorded
};
